import BaseIcon from "./BaseIcon";
import React, { ReactElement, SVGProps } from "react";

export default function ClipboardIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path d="M15.563 14.25a.563.563 0 0 1-.563.563H9a.563.563 0 1 1 0-1.125h6a.563.563 0 0 1 .563.563M15 10.688H9a.563.563 0 1 0 0 1.125h6a.563.563 0 1 0 0-1.125M20.063 4.5v15.75a1.313 1.313 0 0 1-1.313 1.313H5.25a1.313 1.313 0 0 1-1.312-1.313V4.5A1.313 1.313 0 0 1 5.25 3.188h3.484a4.305 4.305 0 0 1 6.531 0h3.485A1.313 1.313 0 0 1 20.063 4.5M8.813 6v.188h6.375V6a3.188 3.188 0 0 0-6.375 0m10.125-1.5a.19.19 0 0 0-.188-.188h-2.782c.228.533.345 1.108.344 1.688v.75a.563.563 0 0 1-.563.563H8.25a.563.563 0 0 1-.563-.563V6c0-.58.116-1.154.344-1.688H5.25a.19.19 0 0 0-.188.188v15.75a.19.19 0 0 0 .188.188h13.5a.19.19 0 0 0 .188-.188z" fill="currentColor"/>
    </BaseIcon>
  );
}
